import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import type { ProxyHealth } from '@/client/types/dashboard';
import { useQuery } from '@tanstack/react-query';

export const createProxyHealthKey = () => ['dashboard', 'health'] as const;

async function fetchProxyHealth(): Promise<ProxyHealth> {
  const response = await fetch('/health', {
    credentials: 'include',
    cache: 'no-store',
  });
  if (!response.ok) {
    throw new Error(`Health check failed (${response.status})`);
  }
  return response.json();
}

export const useProxyHealthQuery = () =>
  useQuery({
    queryKey: createProxyHealthKey(),
    queryFn: fetchProxyHealth,
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    refetchInterval: 30_000,
  });
